import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api, { API, eur, formatApiError } from "@/lib/api";
import { fmtDuration } from "@/lib/videoUpload";

export default function Galleria({ kind = "gallery" }) {
  const { token } = useParams();
  const [sp, setSp] = useSearchParams();
  const sid = sp.get("session_id");
  const [g, setG] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [zoom, setZoom] = useState(null);
  const load = () => api.get(`/public/${kind}/${token}`).then((r) => setG(r.data)).catch((e) => setErr(formatApiError(e)));
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!sid) return;
    let n = 0;
    const tick = async () => {
      try {
        const r = (await api.get(`/payments/status/${sid}`)).data;
        if (r.payment_status === "paid") { setSp({}, { replace: true }); load(); return; }
      } catch { /* riprova */ }
      if (++n < 15) setTimeout(tick, 2000);
    };
    tick();
  }, [sid]); // eslint-disable-line react-hooks/exhaustive-deps
  const pay = async () => {
    setBusy(true);
    try { window.location.href = (await api.post(`/public/gallery/${token}/checkout`, { origin_url: window.location.origin })).data.checkout_url; }
    catch (e) { setErr(formatApiError(e)); setBusy(false); }
  };
  const base = `${API}/public/${kind}/${token}`;
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-cyan-100 p-4" data-testid="public-gallery">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-5">
          <h1 className="text-2xl font-bold text-slate-900">Blu Lodge Maldives</h1>
          {g && <p className="text-sm text-slate-600">{g.title} · {g.photos.filter((p) => p.kind !== "video").length} foto{g.photos.some((p) => p.kind === "video") ? ` · ${g.photos.filter((p) => p.kind === "video").length} video` : ""}</p>}
        </div>
        {err && <p className="text-center text-rose-600" data-testid="gallery-error">{err}</p>}
        {sid && !err && <p className="text-center text-slate-500 mb-3" data-testid="gallery-checking">Verifica del pagamento in corso… · Checking payment…</p>}
        {g && (
          <>
            <div className="bg-white rounded-2xl shadow p-4 mb-5 flex flex-wrap items-center justify-center gap-3 text-center">
              {g.paid ? (
                <>
                  <span className="text-emerald-700 font-semibold" data-testid="gallery-paid">Pacchetto acquistato, grazie! · Purchased, thank you!</span>
                  <a href={`${base}/zip`} className="px-4 py-2 rounded-lg bg-sky-700 text-white font-semibold" data-testid="gallery-zip">Scarica tutte (ZIP) · Download all</a>
                </>
              ) : (
                <>
                  <span className="text-slate-700">Pacchetto completo · Full package <b className="text-sky-800 text-lg" data-testid="gallery-price">{eur(g.price)}</b></span>
                  {g.card_enabled
                    ? <button onClick={pay} disabled={busy} className="px-5 py-2.5 rounded-lg bg-sky-700 text-white font-semibold hover:bg-sky-800" data-testid="gallery-pay">{busy ? "…" : "Acquista con carta · Buy by card"}</button>
                    : <span className="w-full text-sm text-slate-600" data-testid="gallery-pay-desk">Paga alla reception per sbloccare il download · Pay at the reception to unlock the download</span>}
                </>
              )}
              <span className="w-full text-[11px] text-slate-400">Disponibili fino al · Available until {g.expires_at.slice(0, 10).split("-").reverse().join("/")}</span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" onContextMenu={(e) => !g.paid && e.preventDefault()}>
              {g.photos.map((p) => (
                <div key={p.id} className="relative bg-white rounded-lg overflow-hidden shadow-sm" data-testid={`gallery-photo-${p.id}`}>
                  {p.kind === "video" && <span className="absolute top-1 right-1 text-[10px] font-bold bg-slate-900/80 text-white px-1.5 rounded">VIDEO {fmtDuration(p.duration)}</span>}
                  <img src={`${base}/preview/${p.id}`} alt="" loading="lazy" draggable={false} onClick={() => setZoom(p.id)} className="w-full aspect-square object-cover cursor-zoom-in select-none" />
                  {g.paid && <a href={`${base}/original/${p.id}`} className="block text-center text-xs font-semibold text-sky-700 py-1.5" data-testid={`gallery-dl-${p.id}`}>Scarica · Download</a>}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      {zoom && (
        <div className="fixed inset-0 bg-black/80 grid place-items-center p-4 z-50" onClick={() => setZoom(null)} data-testid="gallery-zoom">
          <img src={`${base}/preview/${zoom}`} alt="" draggable={false} className="max-h-[90vh] max-w-full rounded" />
        </div>
      )}
    </div>
  );
}
